import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Adresbezorgbaarheid controleren',
  or: 'of',
  form: {
    company: {
      label: 'Selecteer restaurant',
    },
    address: {
      label: 'Typ het adres in',
    },
  },
  result: {
    positive: '{{address}} komt in aanmerking voor externe bezorging',
    negative: '{{address}} komt niet in aanmerking voor externe bezorging',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Controleren',
  },
  toasts: {
    error: 'Adresbezorgbaarheid controleren mislukt',
  },
};
